import { TargetPay } from "../../../dispatch/src/TargetPay";
import { LoadBoardsTable } from "../LoadBoardsTable";
import { RoutingGuidesTable } from "../RoutingGuidesTable";
import { TopMatchTable } from "../TopMatchTable";
import { CityState, DataSource, Label, Layout, LayoutHeader, Panel, SearchPanel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopMatchList extends Layout {
    citystateConsignee: CityState;
    citystateCustomer: CityState;
    citystateShipper: CityState;
    label5: Label;
    labelCommodity: Label;
    labelConsignee: Label;
    labelCustomer: Label;
    labelCustomerAddress: Label;
    labelCustomerInformation: Label;
    labelDelivery: Label;
    labelDeliveryD: Label;
    labelDestLatestArrival: Label;
    labelDestLatestArrivalD: Label;
    labelDestScheduledArrival: Label;
    labelDestScheduledArrivalD: Label;
    labelDistance: Label;
    labelLatestArrival: Label;
    labelLatestArrivalD: Label;
    labelOfferLog: Label;
    labelPickup: Label;
    labelPickupD: Label;
    labelScheduledArrival: Label;
    labelScheduledArrivalD: Label;
    labelShipper: Label;
    labelStopSummary: Label;
    labelTrailerType: Label;
    labelWeight: Label;
    layoutLoadBoards: LoadBoardsTable;
    layoutRoutingGuides: RoutingGuidesTable;
    layoutTargetPay: TargetPay;
    layoutTopMatch: TopMatchTable;
    layoutheaderTopMatch: LayoutHeader;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panelDeliveryTimes: Panel;
    panelDeliveryTimesD: Panel;
    panelDestDifDay: Panel;
    panelDestSameDay: Panel;
    panelMoney: Panel;
    panelOfferDetails: Panel;
    panelOriginDifDay: Panel;
    panelOriginSameDay: Panel;
    panelOverview: Panel;
    panelPickupAndDelivery: Panel;
    panelPickupTimes: Panel;
    panelPickupTimesD: Panel;
    panelSummaryIcons: Panel;
    searchpanelFilter: SearchPanel;
    sourceMovement: DataSource;
    sourceOfferOverride: DataSource;
    sourceTopMatch: DataSource;
    switchAllowCounter: Switch;
    tabLoadBoards: Tab;
    tabOfferDetails: Tab;
    tabRoutingGuides: Tab;
    tabTopMatch: Tab;
    tabsetOfferDetails: Tabset;
    tabsetTopMatch: Tabset;
    textboxBrokeragePlanningProfile: Textbox;
    textboxCarrierPay: Textbox;
    textboxComments: Textbox;
    textboxDateRange: Textbox;
    textboxEmailSubject: Textbox;
    textboxFloodOffers: Textbox;
    textboxMaxPay: Textbox;
    textboxMoveDistance: Textbox;
    textboxMovementId: Textbox;
    textboxOfferRate: Textbox;
    textboxOrderId: Textbox;
    textboxOrdersEquipmentTypeId: Textbox;
    textboxOrdersWeight: Textbox;
    textboxOrderscommodityId: Textbox;
    textboxOrderspnnRate: Textbox;
    textboxPayMethod: Textbox;
    textboxPayUnits: Textbox;
    textboxQualificationProfile: Textbox;
    textboxQualificationStatus: Textbox;
    textboxRate: Textbox;
    textboxStopDestschedArriveEarl: Textbox;
    textboxStopDestschedArriveEarly: Textbox;
    textboxStopDestschedArriveEarlyD: Textbox;
    textboxStopOriginschedArriveEarl: Textbox;
    textboxStopOriginschedArriveEarly: Textbox;
    textboxStopOriginschedArriveEarlyD: Textbox;
    textboxTopMatchProfile: Textbox;
    textboxTrailerType: Textbox;
}
